import { Dimensions } from "./types";

const calculateResizedDimensions = ({ width, height, max }: Dimensions) => {
  let newWidth = width;
  let newHeight = height;

  // Check if either width or height exceeds max pixels
  if (newWidth > max || newHeight > max) {
    // Calculate aspect ratio
    const aspectRatio = newWidth / newHeight;

    // If width exceeds max, resize width to max and adjust height accordingly
    if (newWidth > max) {
      newWidth = max;
      newHeight = newWidth / aspectRatio;
    }

    // If height exceeds max, resize height to max and adjust width accordingly
    if (newHeight > max) {
      newHeight = max;
      newWidth = newHeight * aspectRatio;
    }
  }

  return { width: Math.round(newWidth), height: Math.round(newHeight) };
};
export { calculateResizedDimensions };
